class Menu {
    groups: MenuGroup[];

    public static getMainMenu(): Menu {
        let overviewGroup = {
            name: '系统概览',
            permission: 'system-overview',
            filterTenantFeatures: false,
            items: [
                {
                    name: '系统总览',
                    path: '/dashboard',
                    permission: 'system-overview.dashboard',
                },
                {
                    name: '数据大屏',
                    path: '/big-screen/overview',
                    permission: 'system-overview.big-screen',
                },
                {
                    name: 'AI助手',
                    path: '/ai-assistant',
                    permission: 'system-overview.ai-assistant',
                },
            ],
        };

        let deviceGroup = {
            name: '设备管理',
            permission: 'device-management',
            filterTenantFeatures: true,
            items: [
                {
                    name: '设备列表',
                    path: '/device-management',
                    permission: 'device-management.device',
                },
                {
                    name: '设备分组',
                    path: '/device-group-management',
                    permission: 'device-management.device-group',
                },
                {
                    name: '设备模板',
                    path: '/device-template-management',
                    permission: 'device-management.device-template',

                },
                {
                    name: '网关管理',
                    path: '/gateway-management',
                    permission: 'device-management.gateway',
                },
                {
                    name: '产品管理',
                    path: '/product-management',
                    permission: 'device-management.product-management',
                },
            ],
        };

        let alarmGroup = {
            name: '告警管理',
            permission: 'alarm-management',
            filterTenantFeatures: true,
            items: [
                {
                    name: '告警事件',
                    path: 'alarm-events',
                    permission: 'alarm-management.alarm-events',
                },
                {
                    name: '告警规则',
                    path: 'alarm-rules',
                    permission: 'alarm-management.alarm-rules',
                },
                {
                    name: '设备故障',
                    path: 'device-failures',
                    dataSummaryTenantOnly: true,
                }
            ],
        };

        let dataGroup = {
            name: '数据中心',
            permission: 'data-center',
            filterTenantFeatures: true,
            items: [
                {
                    name: '设备上下线记录',
                    path: '/device-online-offline-history',
                    permission: 'data-center.device-online-offline-history',
                },
                {
                    name: '设备历史数据',
                    path: '/device-metrics-management',
                    permission: 'data-center.device-metrics-management',
                }
            ],
        };

        let otaGroup = {
            name: 'OTA',
            permission: 'ota',
            filterTenantFeatures: false,
            items: [
                {
                    name: '固件管理',
                    path: '/firmware-management',
                    permission: 'ota.firmware-management',
                },
                {
                    name: '固件推送',
                    path: '/firmware-push-management',
                    permission: 'ota.firmware-push-management',
                }
            ],
        };

        let systemSettingsGroup = {
            name: '系统设置',
            filterTenantFeatures: false,
            items: [
                {
                    name: '用户管理',
                    path: '/user-management'
                },
                {
                    name: '角色管理',
                    path: '/role-management'
                },
            ],
        };

        let secondDevelopmentGroup = {
            name: '二次开发',
            permission: 'open-api',
            filterTenantFeatures: true,
            items: [
                {
                    name: '开放接口',
                    path: '/open-api',
                    permission: 'open-api'
                }
            ]
        };

        return {
            groups: [
                overviewGroup,
                deviceGroup,
                alarmGroup,
                dataGroup,
                otaGroup,
                systemSettingsGroup,
                secondDevelopmentGroup
            ],
        }
    }
}

class MenuGroup {
    name: string;
    items: MenuItem[];
    permission?: string;
    filterTenantFeatures?: boolean;
}

class MenuItem {
    name: string;
    path: string;
    permission?: string;
}

export default Menu;
export { Menu, MenuGroup, MenuItem};
